/* eslint-disable @typescript-eslint/no-explicit-any */
import { Response } from "../api.interface";
import { ActivityInfoVO } from "./invitePolitely.interface";
import newColorAxiosInstance from "@/common-components-src/api/new-color-axiosInstance";

// 查询邀请有礼活动基础信息
export const fetchGetActivityApi = (): Promise<Response<ActivityInfoVO>> => {
  return newColorAxiosInstance
    .post<Response<ActivityInfoVO>>("marketing_interact_getInteractActivity", undefined, {
      params: {
        terminal: 2,
        channel: 101,
        activityType: 1,
      },
    })
    .then((response: any) => response.data)
    .catch((err: any) => err);
};

// 查询邀请有礼活动详细信息
export const getActivityDetailApi = (): Promise<Response<any>> => {
  return newColorAxiosInstance
    .post<Response<ActivityInfoVO>>("marketing_interact_getActivityDetail", undefined, {
      params: {
        terminal: 2,
        channel: 101,
        activityType: 1,
      },
    })
    .then((response: any) => response.data)
    .catch((err: any) => err);
};

// 查询邀请人/受邀人获得的奖励
export const getActivityGiftApi = (activityId: string): Promise<Response<any>> => {
  return newColorAxiosInstance
    .post<Response<ActivityInfoVO>>("marketing_interact_getActivityAwards", undefined, {
      params: {
        terminal: 2,
        channel: 101,
        userIdentity: 1,
        activityId,
      },
    })
    .then((response: any) => response.data)
    .catch((err: any) => err);
};

// 查询邀请人任务进度详情
export const getTaskProcessDetailApi = (params: any): Promise<Response<any>> => {
  const { activityId, processType, currentPage, pageSize } = params;
  return newColorAxiosInstance
    .post<Response<ActivityInfoVO>>("marketing_interact_getParticipantList", undefined, {
      params: {
        terminal: 2,
        channel: 101,
        activityId,
        processType,
        currentPage,
        pageSize,
      },
    })
    .then((response: any) => response.data)
    .catch((err: any) => err);
};

// 查询活动状态且 分享上报
export const getCheckshareActivityApi = (activityId: string): Promise<Response<any>> => {
  return newColorAxiosInstance
    .post<Response<ActivityInfoVO>>("marketing_interact_shareActivity", undefined, {
      params: {
        terminal: 2,
        channel: 101,
        activityId,
      },
    })
    .then((response: any) => response.data)
    .catch((err: any) => err);
};
